const initializeCookieBanner = () => {
	const cookieBanner = document.querySelector('.cookie-banner')
	const cookieBannerReactivate = document.querySelector('.cookie-banner__reactivate')
	if (!window.localStorage.getItem('matomo')) {
		cookieBanner.style.display = 'flex'
		cookieBannerReactivate.style.display = 'none'
	}
	cookieBanner.querySelector('.cookie-banner__btn').addEventListener('click', () => {
		if (!window.localStorage.getItem('matomo')) {
			window.localStorage.setItem('matomo', true)
		}
		cookieBanner.style.display = 'none'
		cookieBannerReactivate.style.display = 'block'
	})
	cookieBannerReactivate.addEventListener('click', () => {
		cookieBanner.style.display = 'flex'
		cookieBannerReactivate.style.display = 'none'
	})
}

export default initializeCookieBanner
